<template>
  <w-sliding-popup ref="slidingPopup" title="템플릿 불러오기" width="600px" @close="onClosePopup">
    <div slot="content">
      <el-row type="flex" justify="space-between" class="title-bar">
        <div class="title-h4">템플릿 목록</div>
        <el-button size="small" type="plain" @click="showSearchTool = !showSearchTool"><i class="fas fa-search" /></el-button>
      </el-row>
      <el-table-wrapper style="width:100%;" ref="templateTable" :data="templateData" :columns="columns" :column-default="columnDefault" :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool" highlight-current-row @row-click="onClickRow">
        <template slot="delete-icon" slot-scope="scope">
          <span @click="onClickDeleteButton(scope.row)"><i class="far fa-times c-pointer" /></span>
        </template>
      </el-table-wrapper>
    </div>

    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" type="solid" size="large" @click="onClickImportButton">불러오기</el-button>
      <el-button size="large" @click="onClosePopup">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { isEmpty } from '@/utils/basic';
import { getDateToString } from '@/utils/date';
import ChartAPI from '@/api/chart/chart-analysis';

export default {
  name: 'WImportTemplatePopup',
  data() {
    return {
      columnDefault,
      columns: [
        { prop: 'templateName', label: '템플릿 명', sortable: true, searchable: true },
        { prop: 'checkDatetime', label: '변경 일시', sortable: true, searchable: true, searchType: 'date', formatter: this.formatCheckDatetime },
        { prop: 'deleteTemplate', label: '삭제', width: 80, scopedSlot: 'delete-icon' },
      ],
      templateData: [],
      showSearchTool: false,
      selectedTemplate: {},
    };
  },
  methods: {
    /**
     * 슬라이딩 팝업을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open() {
      this.$refs.slidingPopup.visible = true;
      this.getPerfChartTemplate();
    },
    /**
     * 차트 템플릿 목록을 불러온다.
     * @return {[type]} [description]
     * @author jda
     */
    getPerfChartTemplate() {
      ChartAPI.getPerfChartTemplateByManager().then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.templateData = result;

          this.$nextTick(() => {
            if (!isEmpty(result)) {
              this.$refs.templateTable.$children[0].setCurrentRow(result[0]);
              this.selectedTemplate = result[0];
            }
          });
        }
      });
    },

    /**
     * 슬라이딩 팝업을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 생성 시각을 YYYY-MM-DD HH:mm:ss 형식으로 변환한다.
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatCheckDatetime(row, column, value) {
      return getDateToString(value);
    },
    /**
     * 템플릿 삭제 버튼 클릭시
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     * @author jda
     */
    onClickDeleteButton(row) {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE))
        .then(() => {
          ChartAPI.deletePerfChartTemplate({ templateSeq: row.templateSeq }).then((response) => {
            if (response.data.success) {
              this.getPerfChartTemplate();
            }
          });
        })
        .catch();
    },
    onClickRow(row) {
      this.selectedTemplate = row;
    },
    onClickImportButton() {
      const selectedTemplate = this.selectedTemplate;
      if (isEmpty(selectedTemplate)) {
        return;
      }

      ChartAPI.getPerfChartTemplate(selectedTemplate.templateSeq)
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.$emit('resetChart', result);
            this.onClosePopup();
          }
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/chart/components/popup/ImportTemplatePopup.vue